import { Menu, MenuProps } from 'antd';
import clsx from 'clsx';
import ModalContactUs, {
  useModalContactUsRef,
} from 'features/report/pages/ReportPage/EmployeeSalary/PrintCheck/ModalContactUs';
import { get } from 'lodash';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import { MenuTabs } from '../v2/style';
import CleaningFeeTab from './CleaningFeeTab';
import WorkingTime from './GeneralConfigurationTabMenu/WorkingTime';
import NotificationSetting from './NotificationSetting';
import Check from './PaymentTabMenu/Check';
import TabConsentForm from './PaymentTabMenu/ConsentForm';
import Discount from './PaymentTabMenu/Discount';
import GiftCard from './PaymentTabMenu/GiftCard';
import LoyaltyRewards from './PaymentTabMenu/LoyaltyRewards';
import PrintCheck from './PaymentTabMenu/PrintCheck';
import ProductTax from './PaymentTabMenu/ProductTax';
import ReferralConfig from './PaymentTabMenu/Referral';
import Tax from './PaymentTabMenu/Tax';
import TipOptionsConfig from './PaymentTabMenu/TipOptionConfig';
import tab_check_active_icon from './v2-icons/tab-check-active.svg';
import tab_check_icon from './v2-icons/tab-check.svg';
import tab_consent_form_active_icon from './v2-icons/tab-consent-form-active.png';
import tab_consent_form_icon from './v2-icons/tab-consent-form.png';
import tab_discount_active_icon from './v2-icons/tab-discount-active.svg';
import tab_discount_icon from './v2-icons/tab-discount.svg';
import tab_fee_active_icon from './v2-icons/tab-fee-active.svg';
import tab_fee_icon from './v2-icons/tab-fee.svg';
import tab_gift_card_active_icon from './v2-icons/tab-gift-card-active.svg';
import tab_gift_card_icon from './v2-icons/tab-gift-card.svg';
import tab_loyalty_rewards_active_icon from './v2-icons/tab-loyalty-rewards-active.svg';
import tab_loyalty_rewards_icon from './v2-icons/tab-loyalty-rewards.svg';
import tab_referral_active_icon from './v2-icons/tab-referral-active.svg';
import tab_referral_icon from './v2-icons/tab-referral.svg';
import tab_role_active_icon from './v2-icons/tab-role-active.png';
import tab_role_icon from './v2-icons/tab-role.png';
import tab_tax_active_icon from './v2-icons/tab-tax-active.svg';
import tab_tax_icon from './v2-icons/tab-tax.svg';
import tab_tip_options_active_icon from './v2-icons/tab-tip-options-active.svg';
import tab_tip_options_icon from './v2-icons/tab-tip-options.svg';
import tab_working_time_active_icon from './v2-icons/tab-working-time-active.svg';
import tab_working_time_icon from './v2-icons/tab-working-time.svg';
import tab_notification_active_icon from './v2-icons/tab_notification_active_icon.svg';
import tab_notification_icon from './v2-icons/tab_notification_icon.svg';
import tab_email_cpa_icon from './v2-icons/tab_email_cpa_icon.svg';
import tab_email_cpa_active_icon from './v2-icons/tab_email_cpa_active_icon.svg';
import tab_permission_icon from './v2-icons/tab_permission_icon.svg';
import tab_permission_active_icon from './v2-icons/tab_permission_active_icon.svg';
import SendEmailCPA from './SendEmailCPA';
import PermissionManager from 'widgets/PermissionVerify';
import RolePermissionSetting from './RolePermission';

type IPaymentsTabProps = {
  v2?: boolean;
};
type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

enum MenuKeys {
  TAX = 'tax',
  DISCOUNT = 'discount',
  TIP_OPTIONS = 'tip_options',
  LOYALTY_REWARDS = 'loyalty_rewards',
  REFERRAL = 'referral',
  CHECK = 'check',
  GIFT_CARD = 'gift_card',
  WORKING_TIME = 'working',
  CLEANING_FEE = 'cleaning_fee',
  PRODUCT_TAX = 'product_tax',
  PRINT_CHECK = 'print_check',
  CONSENT_FORM = 'consent_form',
  NOTIFICATION = 'notification',
  SEND_EMAIL_CPA = 'send_email_cpa',
  PERMISSION = 'PERMISSION',
}

const items: MenuItem[] = [
  getItem('Tax', MenuKeys.TAX),
  getItem('Discount', MenuKeys.DISCOUNT),
  getItem('Tip Options', MenuKeys.TIP_OPTIONS),
  getItem('Loyalty Rewards', MenuKeys.LOYALTY_REWARDS),
  getItem('Referral', MenuKeys.REFERRAL),
  getItem('Check (Others)', MenuKeys.CHECK),
  getItem('Gift Card', MenuKeys.GIFT_CARD),
  getItem('Consent Form', MenuKeys.CONSENT_FORM),
  getItem('Working Time', MenuKeys.WORKING_TIME),
  getItem('Product Tax', MenuKeys.PRODUCT_TAX),
  getItem('Print Check', MenuKeys.PRINT_CHECK),
  getItem('Notification', MenuKeys.NOTIFICATION),
  getItem('Permission', MenuKeys.PERMISSION),
];

const tabPermissionMapping = {
  [MenuKeys.TAX]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_TAX,
  [MenuKeys.DISCOUNT]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_DISCOUNT,
  [MenuKeys.TIP_OPTIONS]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_TIP_OPTIONS,
  [MenuKeys.LOYALTY_REWARDS]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_LOYALTY,
  [MenuKeys.REFERRAL]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_REFERRAL,
  [MenuKeys.CHECK]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_CHECK,
  [MenuKeys.GIFT_CARD]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_GIFT_CARD,
  [MenuKeys.WORKING_TIME]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_WORKING_TIME,
  [MenuKeys.CLEANING_FEE]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_CLEANING_FEE,
  [MenuKeys.PRODUCT_TAX]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_PRODUCT_TAX,
  [MenuKeys.PRINT_CHECK]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_PRINT_CHECK,
  [MenuKeys.NOTIFICATION]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_NOTI,
  [MenuKeys.SEND_EMAIL_CPA]: PermissionManager.PERMISSIONS.CONTROL_PANEL_CONGIGURATIONS_SEND_CPA,
};

const PaymentsTab: React.FC<IPaymentsTabProps> = ({ v2 }) => {
  const allSetting = shopSelectors.data.allSetting();
  const modalContactUsRef = useModalContactUsRef();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const query = new URLSearchParams(search);
  const selectedKey = (query.get('menuKey') as MenuKeys) || MenuKeys.TAX;

  const handleMenuSelect = async (info: { key: string }) => {
    const callback = () => {
      const path = `${pathname}?menuKey=${info.key}`;
      navigate(path);
    };
    const permission = tabPermissionMapping[info.key as keyof typeof tabPermissionMapping];
    if (permission) {
      const result = await PermissionManager.verify(permission);
      if (!result || result?.skip) return callback();
      if (!result.verifyData) return;
    }
    callback();
  };
  const onChooseTab = (key: MenuKeys) => async () => {
    const callback = () => {
      if (key === MenuKeys.PRINT_CHECK) {
        if (!allSetting?.displayPrintCheck) return modalContactUsRef.current?.open();
      }
      const path = `${pathname}?menuKey=${key}`;
      navigate(path);
    };

    const result = await PermissionManager.verify(tabPermissionMapping[key as keyof typeof tabPermissionMapping]);
    if (!result || result?.skip) return callback();
    if (!result.verifyData) return;
    callback();
  };

  return (
    <PaymentsTabStyled className={v2 ? 'v2' : ''}>
      <BoxStyled>
        <LeftBoxStyled className='LeftBoxStyled'>
          {v2 ? (
            <MenuTabs>
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.TAX)}
                active={selectedKey === MenuKeys.TAX}
                type={MenuKeys.TAX}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.DISCOUNT)}
                active={selectedKey === MenuKeys.DISCOUNT}
                type={MenuKeys.DISCOUNT}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.TIP_OPTIONS)}
                active={selectedKey === MenuKeys.TIP_OPTIONS}
                type={MenuKeys.TIP_OPTIONS}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.LOYALTY_REWARDS)}
                active={selectedKey === MenuKeys.LOYALTY_REWARDS}
                type={MenuKeys.LOYALTY_REWARDS}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.REFERRAL)}
                active={selectedKey === MenuKeys.REFERRAL}
                type={MenuKeys.REFERRAL}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.CHECK)}
                active={selectedKey === MenuKeys.CHECK}
                type={MenuKeys.CHECK}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.GIFT_CARD)}
                active={selectedKey === MenuKeys.GIFT_CARD}
                type={MenuKeys.GIFT_CARD}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.CONSENT_FORM)}
                active={selectedKey === MenuKeys.CONSENT_FORM}
                type={MenuKeys.CONSENT_FORM}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.WORKING_TIME)}
                active={selectedKey === MenuKeys.WORKING_TIME}
                type={MenuKeys.WORKING_TIME}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.CLEANING_FEE)}
                active={selectedKey === MenuKeys.CLEANING_FEE}
                type={MenuKeys.CLEANING_FEE}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.PRODUCT_TAX)}
                active={selectedKey === MenuKeys.PRODUCT_TAX}
                type={MenuKeys.PRODUCT_TAX}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.PRINT_CHECK)}
                active={selectedKey === MenuKeys.PRINT_CHECK}
                type={MenuKeys.PRINT_CHECK}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.NOTIFICATION)}
                active={selectedKey === MenuKeys.NOTIFICATION}
                type={MenuKeys.NOTIFICATION}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.SEND_EMAIL_CPA)}
                active={selectedKey === MenuKeys.SEND_EMAIL_CPA}
                type={MenuKeys.SEND_EMAIL_CPA}
              />
              <MenuTabItem
                onClick={onChooseTab(MenuKeys.PERMISSION)}
                active={selectedKey === MenuKeys.PERMISSION}
                type={MenuKeys.PERMISSION}
              />
            </MenuTabs>
          ) : (
            <MenuBoxStyled>
              <Menu
                style={{ width: '100%' }}
                defaultSelectedKeys={[MenuKeys.TAX]}
                items={items}
                onSelect={handleMenuSelect}
              />
            </MenuBoxStyled>
          )}
        </LeftBoxStyled>

        <RightBoxStyled>
          {selectedKey === MenuKeys.TAX && <Tax v2={v2} />}
          {selectedKey === MenuKeys.DISCOUNT && <Discount />}
          {selectedKey === MenuKeys.TIP_OPTIONS && <TipOptionsConfig v2={v2} />}
          {selectedKey === MenuKeys.LOYALTY_REWARDS && <LoyaltyRewards v2={v2} />}
          {selectedKey === MenuKeys.REFERRAL && <ReferralConfig />}
          {selectedKey === MenuKeys.CHECK && <Check v2={v2} />}
          {selectedKey === MenuKeys.GIFT_CARD && <GiftCard v2={v2} />}
          {selectedKey === MenuKeys.WORKING_TIME && <WorkingTime v2={v2} />}
          {selectedKey === MenuKeys.PRODUCT_TAX && <ProductTax v2={v2} />}
          {selectedKey === MenuKeys.CLEANING_FEE && <CleaningFeeTab />}
          {selectedKey === MenuKeys.CONSENT_FORM && <TabConsentForm />}
          {selectedKey === MenuKeys.PRINT_CHECK && <PrintCheck />}
          {selectedKey === MenuKeys.NOTIFICATION && <NotificationSetting />}
          {selectedKey === MenuKeys.SEND_EMAIL_CPA && <SendEmailCPA />}
          {selectedKey === MenuKeys.PERMISSION && <RolePermissionSetting />}
        </RightBoxStyled>
        <ModalContactUs ref={modalContactUsRef} />
      </BoxStyled>
    </PaymentsTabStyled>
  );
};

export default PaymentsTab;

const configs = {
  [MenuKeys.TAX]: {
    label: 'Tax',
    icon: tab_tax_icon,
    icon_active: tab_tax_active_icon,
  },
  [MenuKeys.DISCOUNT]: {
    label: 'Discounts',
    icon: tab_discount_icon,
    icon_active: tab_discount_active_icon,
  },
  [MenuKeys.TIP_OPTIONS]: {
    label: 'Tip Options',
    icon: tab_tip_options_icon,
    icon_active: tab_tip_options_active_icon,
  },
  [MenuKeys.LOYALTY_REWARDS]: {
    label: 'Loyalty Rewards',
    icon: tab_loyalty_rewards_icon,
    icon_active: tab_loyalty_rewards_active_icon,
  },
  [MenuKeys.REFERRAL]: {
    label: 'Referrals',
    icon: tab_referral_icon,
    icon_active: tab_referral_active_icon,
  },
  [MenuKeys.CHECK]: {
    label: 'Check (Others)',
    icon: tab_check_icon,
    icon_active: tab_check_active_icon,
  },
  [MenuKeys.GIFT_CARD]: {
    label: 'Gift Card',
    icon: tab_gift_card_icon,
    icon_active: tab_gift_card_active_icon,
  },
  [MenuKeys.WORKING_TIME]: {
    label: 'Working Time',
    icon: tab_working_time_icon,
    icon_active: tab_working_time_active_icon,
  },
  [MenuKeys.CLEANING_FEE]: {
    label: 'Cleaning Fees',
    icon: tab_fee_icon,
    icon_active: tab_fee_active_icon,
  },
  [MenuKeys.CONSENT_FORM]: {
    label: 'Consent Forms',
    icon: tab_consent_form_icon,
    icon_active: tab_consent_form_active_icon,
  },
  [MenuKeys.PRODUCT_TAX]: {
    label: 'Product Tax',
    icon: tab_role_icon,
    icon_active: tab_role_active_icon,
  },
  [MenuKeys.PRINT_CHECK]: {
    label: 'Print Checks',
    icon: tab_check_icon,
    icon_active: tab_check_active_icon,
  },
  [MenuKeys.NOTIFICATION]: {
    label: 'Notification',
    icon: tab_notification_icon,
    icon_active: tab_notification_active_icon,
  },
  [MenuKeys.SEND_EMAIL_CPA]: {
    label: 'Send Email CPA',
    icon: tab_email_cpa_icon,
    icon_active: tab_email_cpa_active_icon,
  },
  [MenuKeys.PERMISSION]: {
    label: 'Positions & Roles',
    icon: tab_permission_icon,
    icon_active: tab_permission_active_icon,
  },
};

type IMenuTabItemProps = {
  active?: boolean;
  onClick?: () => void;
  type: MenuKeys;
};
const MenuTabItem = ({ type, active, onClick }: IMenuTabItemProps) => {
  const config = get(configs, type);
  if (!config) return null;
  return (
    <div className={clsx('menu-tab-item', active && 'active')} onClick={onClick}>
      <img src={active ? config.icon_active : config.icon} alt={config.label} style={{ width: 32, height: 32 }} />
      <span>{config.label}</span>
    </div>
  );
};

const PaymentsTabStyled = styled.div`
  display: flex;
  flex-direction: column;
  background: #e5e5e5;
  height: 100%;
`;

const BoxStyled = styled.div`
  display: flex;
  flex-grow: 1;
`;

const LeftBoxStyled = styled.div`
  width: 409px;
  background-color: white;
  border-right: 1px solid #ccd4dc;
  display: flex;
  flex-direction: column;
`;

const MenuBoxStyled = styled.div`
  padding: 0.25rem 0;
  .ant-menu-item {
    margin: 0;
    width: 100%;
    border-radius: 0;
  }
`;

const RightBoxStyled = styled.div`
  flex: 1;
  max-height: calc(100vh - 69px);
  overflow: auto;
  background-color: #e5e6eb;
`;
